import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { useFileExplorerContext } from "../FileExplorerContext";

export const FileUploadLoadingOverlay: React.FC = () => {
  const { t } = useTenantTranslation();
  const { isLoading, uploadLoading } = useFileExplorerContext();
  if (!isLoading && !uploadLoading) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        backdropFilter: "blur(2px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 2,
          padding: 3,
          boxShadow: 2,
          minWidth: "200px",
          textAlign: "center",
        }}
      >
        <Stack spacing={2} alignItems="center">
          <CircularProgress size={40} />
          <Typography variant="body1" color="text.primary">
            {t("processingFiles")}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
